export const svgColors = {
  sendIcon: "#ffffff",
  socialIcon: "#ffffff",
  mainLogo: "#000000",
  blackIcon: "#000000",
  offeringIcon: "#103E13",
  greenColor: "#4CAF4F",
};
